import { forwardRef } from 'react'
import MuiStack, { StackProps } from '@mui/material/Stack'

/**
 * The Stack component manages layout of immediate children along the vertical
 * or horizontal axis with optional spacing and/or dividers between each child.
 *
 * Documentation: https://mui.com/material-ui/react-stack/
 */
export const Stack = forwardRef<HTMLDivElement, StackProps>(
  (props, ref): JSX.Element => <MuiStack {...props} ref={ref} />
)

Stack.displayName = 'Stack'

export type { StackProps }
